import Axios from 'axios';

const LOGIN_RESOURCE = '/login';
const LOGOUT_RESOURCE = '/logout';

export default {
    login(username, password) {
        return Axios.post(LOGIN_RESOURCE, {'username': username, 'password': password})
    },
    logout() {
        return Axios.post(LOGOUT_RESOURCE)
    }
};
